export abstract class PodeExcluirInativarBase {
    podeExcluir: boolean;
    ativo: boolean;
    podeAtivarInativar: boolean;
    podeEditar: boolean;
}
